import { CpfOrCns } from 'components/CpfOrCns'
import { HLabel } from 'components/HLabel'
import React from 'react'

import { EncaminhamentoExternoLotacao } from '../model'

type EncaminhamentoExternoLotacaoProps = EncaminhamentoExternoLotacao

export function EncaminhamentoExternoDetalheLotacao({ nome, cpf, cns, cbo }: EncaminhamentoExternoLotacaoProps) {
  return (
    <HLabel title='Encaminhado por:'>
      {nome.titleCase()} - <CpfOrCns cpf={cpf} cns={cns} defaultText='' /> | {cbo.titleCase()}
    </HLabel>
  )
}
